<template>
  <div id="topic-raise-modal" class="content">
    <modal :show.sync="shouldShow" @hidden="onClickDismiss" v-on:close="onClickDismiss" footerClasses="justify-content-center" type="notice">
      <h4 slot="header" class="modal-title">
        <b>띄워주기</b>
      </h4>
      <div class="row">
        <div class="col-md-2">
          <h4 class="card-title text-left">타입</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <el-select class="select-primary" size="large" placeholder="선택" v-model="model.type">
                <el-option v-for="option in typeOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <h4 class="card-title text-left">시작시간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="시작시간">
                <el-date-picker type="datetime" placeholder="시작시간" v-model="model.startTime"></el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <h4 class="card-title text-left">종료시간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="종료시간">
                <el-date-picker type="datetime" placeholder="시작시간" v-model="model.endTime"></el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <h4 class="card-title text-left">가중치</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input>
                <select class="form-control" v-model="model.weight">
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  <option>6</option>
                  <option>7</option>
                  <option>8</option>
                  <option>9</option>
                  <option>10</option>
                </select>
              </base-input>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="justify-content-center">
        <base-button class="footer-buttons col-6" type="success" round @click.native="onClickConfirm">확인</base-button>
        <base-button class="footer-buttons col-6" type="danger" round @click.native="onClickDismiss">취소</base-button>
      </div>
    </modal>
  </div>
</template>
<script>
import { BaseInput, Modal } from "@/components/index";
import BaseButton from "@/components/BaseButton";
import { showAPIErrorToast } from "@/util/ErrorUtils";

const DEFAULT_WEIGHT = 5;
const RaiseType = Object.freeze({
  HOT: 1,
  DASHBOARD: 2,
});

export default {
  name: "TopicRaiseModal",
  components: {
    BaseButton,
    BaseInput,
    Modal,
  },
  data() {
    return {
      model: {
        type: RaiseType.HOT,
        weight: DEFAULT_WEIGHT,
        startTime: null,
        endTime: null,
      },
      typeOptions: [
        {
          label: "인기토픽",
          value: RaiseType.HOT,
        },
      ],
    };
  },
  props: {
    topicId: Number,
    shouldShow: {
      type: Boolean,
      required: true,
    },
    onCancel: {
      type: Function,
      required: true,
    },
    onDone: {
      type: Function,
      required: true,
    },
  },
  methods: {
    changeType() {},
    validate: function () {
      const { startTime, endTime } = this.model;
      if (startTime === null || endTime === null) {
        window.Toast.error("시작일과 종료일을 입력해 주세요.");
        return false;
      }

      return true;
    },
    onClickConfirm: async function () {
      const { type } = this.model;
      if (type === RaiseType.HOT) {
        await this.raiseToHot();
      }
    },
    async raiseToHot() {
      if (!this.validate()) {
        return;
      }

      try {
        const { startTime, endTime, weight } = this.model;
        await this.$axios.post(`/topics/${this.topicId}/hotRaises`, {
          startTime,
          endTime,
          weight: parseInt(weight, 10),
        });

        window.Toast.success("띄워주기가 완료되었습니다.");

        this.resetModel();
        this.onClickDismiss();
      } catch (err) {
        showAPIErrorToast(err);
      }
    },

    onClickDismiss: async function () {
      await this.onCancel();
    },
    getArtistInfo(memberId) {
      this.memberIds = memberId;
    },
    resetModel() {
      this.model.startTime = null;
      this.model.endTime = null;
      this.weight = DEFAULT_WEIGHT;
    },
  },
};
</script>

<style lang="scss">
#topic-raise-modal {
  .modal-dialog {
    max-width: 800px !important;
  }

  .member-select {
    margin-bottom: 30px;
  }

  .modal-footer {
    button {
      width: 100px;
      margin-right: 10px;
    }
  }
}
</style>
